import { PageSizing } from 'components/Layout/PageContentWidth';
import { Nav } from 'components/Navigation/NavLayout';
import { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';
import { subRoutes } from './util';
import searchState from 'components/AccessRequests/searchState';
import useDashboardList from 'components/AccessRequests/useDashboardList';
import CreateLayoutModal from 'components/DashboardGrid/CreateLayoutModal';
import {
  DashboardStyleSettingsProvider,
  DEFAULT_DASHLET_STYLE_SETTINGS,
} from 'ts-components/StyleSettings';
import RequestModal from 'components/AccessRequests/modal';
import useDashboardConfig from '../hooks/useDashboardConfig';
import { useSelector } from 'react-redux';
import { getDashboardsAccess } from 'store/authentication/selectors';

const DashboardSettingsController = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { debouncedTerm } = useContext(searchState.Context);
  const dashboardsAccess = useSelector(getDashboardsAccess);

  const {
    modalProps,
    requestModalProps,
    canUserEditPermissions,
    existingDashboard,
    data,
    loading,
    configLoading,
    refetching,
    backToDashboardId,
    errors,
    ...routeProps
  } = useDashboardList(
    { debouncedTerm, type: 'generic_dashboard' },
    useDashboardConfig
  );

  useEffect(() => {
    if (location.pathname === '/dashboard/settings') {
      history.push('/dashboard/settings/mine');
    }
  }, [location, history]);

  const routes = useMemo(() => {
    return subRoutes(true);
  }, []);

  return (
    <>
      <Nav.Container>
        <Nav.SubNavigationRow>
          {routes.map((route, index) => {
            return (
              <Nav.SubNavigationLink
                key={`${route.path}-link`}
                route={{
                  label: route.label(t),
                  path: route.path,
                  icon: route.icon,
                }}
                numberOfLinks={routes.length}
                isLast={index === routes.length - 1}
              />
            );
          })}
        </Nav.SubNavigationRow>
      </Nav.Container>
      <DashboardStyleSettingsProvider
        styleSettings={DEFAULT_DASHLET_STYLE_SETTINGS}
      >
        <CreateLayoutModal
          {...modalProps}
          canUserEditPermissions={canUserEditPermissions}
          showEditAdminOptions
          existing={existingDashboard}
          entity={t('Dashboard')}
          errors={errors}
          forceAdmin
        />
      </DashboardStyleSettingsProvider>
      <RequestModal
        {...requestModalProps}
        dashboard={existingDashboard}
        employeeSectionAccess={dashboardsAccess}
      />
      <PageSizing>
        <Switch>
          {routes.map((route) => {
            return (
              <Route key={route.path} exact={route.exact} path={route.path}>
                {/* These components are the page in /pages */}
                <route.Component
                  goBackPath={
                    backToDashboardId
                      ? `/dashboard/${backToDashboardId}`
                      : '/dashboard'
                  }
                  data={data[route.dataKey] ?? []}
                  loading={loading[route.dataKey] || configLoading}
                  isRefetching={refetching[route.dataKey]}
                  {...routeProps}
                />
              </Route>
            );
          })}
        </Switch>
      </PageSizing>
    </>
  );
};

export default DashboardSettingsController;
